module.exports = __webpack_public_path__ + "img/icon_permisos.f2bde853.svg";